<template>
	<div>
		<v-card-title class="mt-4">
			<h2>Moje opinie eksperckie</h2>
		</v-card-title>
		<agency-project-expert-evaluation-table/>
	</div>
</template>

<script>
	import AgencyProjectExpertEvaluationTable from "./AgencyProjectExpertEvaluationTable";

	export default {
		name: "AgencyProjectExpertEvaluationList",
		components: {AgencyProjectExpertEvaluationTable},
	};
</script>

<style scoped>

</style>